import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeNewActivityTypeCreate,
  detail: routeActivityTypeDetail,
  home: routeActivityTypesHome,
  root: routeActivityTypesRoot,
} = createDoctypeRoutes({
  createName: 'new-activity-type',
  createPath: 'new-activity-type',
  detailName: 'activityTypeDetail',
  doctype: DOCTYPES.ACTIVITY_TYPE,
  homeName: 'activity-types',
  path: 'activity-types',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/activityTypes/AddActivityType.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/activityTypes/ViewActivityType.vue'),
    list: async () => await import('@/components/viewsExternal/activityTypes/ActivityTypeView.vue'),
  },
})

export {
  routeActivityTypeDetail,
  routeActivityTypesHome,
  routeActivityTypesRoot,
  routeNewActivityTypeCreate,
}
